import { LocationPage } from "@/components/locations/LocationPage";
import { getLocationBySlug } from "@/data/locations";

const BookkeepingServicesCapeTown = () => {
  const location = getLocationBySlug("cape-town")!;
  return <LocationPage location={location} />;
};

export default BookkeepingServicesCapeTown;
